import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const AmericanFootball = () => {
  return (
    <SportsLayoutComp name={'American Football'}/>
  )
}

export default AmericanFootball